import { useQuery } from '@tanstack/react-query';
import {
  rateActionApi,
  rateActionKeys,
  type RateActionExtractResponse,
} from '../api/rate-action-api';

const PROCESSING_POLL_INTERVAL_MS = 5000;

export function useRateActionExtractRequest(requestId: string | undefined) {
  return useQuery<RateActionExtractResponse>({
    queryKey: rateActionKeys.detail(requestId ?? ''),
    queryFn: () => rateActionApi.getExtractedData(requestId!),
    enabled: !!requestId,
    // If we land on a record that is still processing (e.g. refresh mid-extract or
    // navigation from the upload flow), poll until it finishes. Once completed/applied
    // /error, stop polling — the record is terminal and only changes via explicit
    // mutations (which invalidate this key).
    refetchInterval: query => {
      const status = query.state.data?.status;
      return status === 'processing' ? PROCESSING_POLL_INTERVAL_MS : false;
    },
  });
}
